import React, { useEffect } from "react";
import { useLocation } from 'react-router-dom';
import { GridStack } from "gridstack";
import { useTranslation } from 'react-i18next';
import GridItem from "../../../../Components/UiComponents/GridItem/GridItem";
import SopInstanceTable from "./Sopinstancetable/SOPInstanceTable";
import DMSHeader from "../../DMSHeader/DMSHeader";

const SopInstance = () => {
  const { t } = useTranslation();

  useEffect(() => {
    GridStack.init();
  }, []);
  const location = useLocation();
  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 12,
      height: 1,
      id: 1,
      component: (
        <DMSHeader
          title={t('sop_instance_list_header')}
          showdownload={true}
          fileName="SOP Instance"
          showmenu={true}
          showImportDropDownLabel={false}
        />
      ),
      haveOverflowVisible: true,
    },
    {
      x: 0,
      y: 1,
      width: 12,
      height: 12,
      id: 2,
      component: <SopInstanceTable locationInstance={location.state} />,
    },
  ];

  return (
    <div className="grid-stack grid-stack-instance-1 smartpole__header--transition">
      <GridItem layoutData={layoutData} />
    </div>
  );
};

export default SopInstance;
